import QRCode from 'qrcode'

export const generateAssetQrCode = async (value) => {
  const stringValue = `${window.location.origin}/scan/assets/${value}`
  return QRCode.toDataURL(stringValue, {
    width: 600,
    margin: 0,
    errorCorrectionLevel: 'M',
  })
}